module.exports = __webpack_public_path__ + "app/assets/fonts/glyphicons-halflings-regular.woff?fa2772327f55d8198301fdb8bcfc8158";


//////////////////
// WEBPACK FOOTER
// ./~/@suntransfers/st-ui/dist/styles/fonts/glyphicons-halflings-regular.woff
// module id = 177
// module chunks = 1